// extracted by mini-css-extract-plugin
export default {"body":"CostUploadHistory_body__fT8cf","fileuploadHistory":"CostUploadHistory_fileuploadHistory__+Rwm8","heading":"CostUploadHistory_heading__I02ME"};